
export const DISTRICT_DEFINITIONS = "/DistrictDef/GetDistrictDefinitions"
export const DISTRICT_INSERT = "/DistrictDef/InsertDistrictDefinition"
export const DISTRICT_UPDATE = "/DistrictDef/UpdateDistrictDefinition"
export const DISTRICT_DELETE = "/DistrictDef/DeleteDistrictDefinition"